export default __webpack_public_path__ + "static/media/Lenses.27677695.png";